var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":_vm.doc.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.doc.title))]),(_vm.auth)?_c('span',{staticClass:"btn btn-sm btn-outline-danger",on:{"click":_vm.remove}},[_vm._v(" delete")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }